import * as React from 'react';
import { MyAccountComponentProps, MyAccountComponentHandler, MyAccountComponentState } from './myaccountcomponent';
import { MyAccountCSSStyle } from './myaccountcss';
import { Strings } from '../../../utils/resources/strings';
import { MyProfileDetailsComponent } from './myprofiledetails/myprofiledetailscomponent';
import { ButtonComponent } from '../../toolkit/button/buttoncomponent';
import { MyAccountDto, MyAccountDtoImpl } from '../../../core/dto/myaccount/myaccountdto';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import { PreferenceCategoryListComponent } from './preferences/preferncecategorylistcomponent';
import { MsisdnTextComponent } from '../../toolkit/text/msisdntext/msisdntextcomponent';
import { CRBTUIViewImpl } from '../home/crbt/crbtuiview';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../popup/confirmrequest/confirmrequestconfirmbuttoncss';
import { ConfirmRequestCancelButtonCSSStyleImpl } from '../popup/confirmrequest/confirmrequestcancelbutoncss';
import { AlertComponent } from '../../toolkit/alert/alertcomponent';
import { AlertType } from '../../toolkit/alert/alerttype';
import { PopUpWrapperComponent } from '../popup/popupwrappercomponent';
import { MemberTextComponent } from '../../toolkit/text/membertext/membertextcomponent';
import { LoaderComponent } from '../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../popup/loaderwrappercomponent';
// import { DeleteConfirmComponent } from '../popup/deleteconfirmation/deleteconfirmationcomponent';
import { RoutingFeatures } from '../navigation/routingfeature';
import './myprofile-style.css';
import { LanguageConst } from '../../../utils/resources/languageconst';
import { RewardPointComponent } from '../popup/rewardpoint/rewardpointcomponent';
import { DeleteConfirmComponent } from '../popup/deleteconfirmation/deleteconfirmationcomponent';
import { RewardPointDto} from '../../../core/dto/rewardpoint/rewardpointdto';

export class MyAccountViewImpl extends CRBTUIViewImpl
{
    private textComponent:any;
    private categoryListComponent :any;
    private popUpComponent: PopUpWrapperComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;

    bindHandlers()
    {
        this.onSaveChangesClick = this.onSaveChangesClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.unsubscribeConfirm = this.unsubscribeConfirm.bind(this);
        this.subscribeConfirm = this.subscribeConfirm.bind(this);
        this.onRewardPointClick = this.onRewardPointClick.bind(this);
    }
    
    getChildComponent(props: MyAccountComponentProps, state: MyAccountComponentState, cssStyle: MyAccountCSSStyle): JSX.Element
    {
        
        return (
            <>
            <div id="myprofile-wrapper" style={cssStyle.getWrapperCSSStyle()}>
            {
                this.getWebView(props, state, cssStyle)
            }
             
            </div>
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            </>
        );
    }

    getWebView(props: MyAccountComponentProps, state: MyAccountComponentState, cssStyle: MyAccountCSSStyle)
    {
        return (
            <>
             <div id="myprofile-main">
                  <MyProfileDetailsComponent onRewardPointClick={this.onRewardPointClick} subscriber={this.subscribe} unSubscriber={this.unsubscribe} status={state.userStatus} context={this.getContext()} profileName={state.username} contactNumber={props.context.getUserContext().getMsisdn()}/>
              </div>
              <div id="myprofile-inner" style={cssStyle.getInnerWrapperCSSStyle()}>
                    <div id="myprofile-input-wrapper" style={cssStyle.getInputWrapperCSSStyle()}>
                        <div id="myprofile-input-username"  style={cssStyle.getInputDiv1CSSStyle()}>
                                <MemberTextComponent hint={this.getContext().getResources().getString(Strings.userName)} maxLength={this.getUIProps().context.getResources().getString(Strings.username_max_length)} label={this.getContext().getResources().getString(Strings.userName)} placeholder={this.getContext().getResources().getString(Strings.userName)}  isDisabled={!state.isEditable} ref={(item: any) => this.textComponent = item} id={"#username"} value={state.username} inputType={"text"} isRequired={true}  context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.usernameerrormsg)}/> 
                        </div>
                        <div id="myprofile-input-msisdn" style={cssStyle.getInputDiv2CSSStyle()}>
                                <MsisdnTextComponent hint={this.getContext().getResources().getString(Strings.mobilenumberhint)} maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} label={this.getContext().getResources().getString(Strings.contact_number)} placeholder={this.getContext().getResources().getString(Strings.contact_number)}  isDisabled={true}  id={"#mobilenumber"} value={props.context.getUserContext().getMsisdn()} inputType={"number"} isRequired={true}  context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/> 
                        </div>
                    </div>    

                    <div id="myprofile-prefernece" style={cssStyle.getCategoriesListDivCSSStyle()}>
                            <PreferenceCategoryListComponent seletedCategories={state.selectedCategories} title={props.context.getResources().getString(Strings.preferences)} isEditable={state.isEditable} ref={(item: any) => this.categoryListComponent = item} listOfDatas={[]} context={props.context}/>             
                    </div>
                    {
                        state.isEditable && 
                        <div id="myprofile-button-row" style={cssStyle.getRowDivCSSStyle()}>
                            <div id="myprofile-save-button" >
                                        <ButtonComponent onClick={this.onSaveChangesClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.saveChanges)}/>
                            </div>
                            <div id="myprofile-cancel-button" style={cssStyle.getCancelButtonDivCSSStyle()}>
                                        <ButtonComponent onClick={this.onCancelClick} style={new ConfirmRequestCancelButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.cancel)}/>
                            </div>
                        </div>
                                    }
                    {
                    !state.isEditable && <div id={props.context.getUserContext().getLanguage() === LanguageConst.ENGLISH ? "myprofile-edit-button" : "myprofile-edit-button-burmese"}>
                                        <ButtonComponent onClick={this.onEditClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.editprofile)}/>
                                    </div>}
                    
              </div>
            </>
        );
    }


    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    showPopup(id: string, msg:string,type:AlertType):void
    {
        this.closePopup();
         if(type === AlertType.WARN)
         {
             
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.tryagain)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

         }
        else if(type === AlertType.SUCCESS)
        {
            
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

        }
         else 
         {
            this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);

         }
         
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    updateCategoriesData(listOfDatas: CategoryDto[])
    {
        this.categoryListComponent.updateListData(listOfDatas);
    }

    subscribeConfirm()
    {
        this.dismissLoader();
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, false);
    }
    subscribe()
    {
  
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.go_to_home)} alertMessage={this.getUIProps().context.getResources().getString(Strings.subscriber_msg)} alertType={AlertType.AUTHENTICATE} onCloseButtonClick={this.closePopup} onClick={this.subscribeConfirm} context={this.getUIProps().context}/>);
    }

    unsubscribeConfirm()
    {
        this.closePopup();
        (this.getUIComponentHandler() as MyAccountComponentHandler).unSubscriber();
    }

    unsubscribe()
    {
        this.popUpComponent.setShowWindow(true, 
            <DeleteConfirmComponent msg={this.getContext().getResources().getString(Strings.unsubscribe_confirm_msg)} id={"delete"}  headerTitle={this.getContext().getResources().getString(Strings.confirm)} closePopup={this.closePopup} context={this.getContext()} onConfirmClick={this.unsubscribeConfirm} onCancelClick={this.closePopup} />);
    }
    getData(): MyAccountDto
    {
        let request = new MyAccountDtoImpl();
        request.setMsisdn(this.getUIProps().context.getUserContext().getMsisdn());
        request.setUserName(this.textComponent.getData());
        request.setCategories(this.categoryListComponent.getSelectedMultiselectCategoryList());

        return request;
    }

    onSaveChangesClick():void
    {
        if(this.categoryListComponent.getSelectedMultiselectCategoryList().length === 0)
       {
        this.showPopup("",this.getUIProps().context.getResources().getString(Strings.categories_error_msg),AlertType.WARN);
       }
       else
       {
        (this.getUIComponentHandler() as MyAccountComponentHandler).onSaveChangesButtonClick();
       }
    }

    onEditClick():void
    {
       (this.getUIComponentHandler() as MyAccountComponentHandler).onEditButtonClick();
    }

    onCancelClick():void
    {
       (this.getUIComponentHandler() as MyAccountComponentHandler).onCancelButtonClick();
    }
    validate(): boolean
    {
        // if(this.numberComponent.validate())
        // {
        //     let numberMinLength = +this.getUIProps().context.getResources().getString(Strings.numberMinLength);
        //     let numbermaxLength = +this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

        //     if(this.numberComponent.getData().length < numberMinLength 
        //                     || this.numberComponent.getData().length > numbermaxLength)
        //     {
        //         this.numberComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
        //         return false;
        //     }
            
        //     return true;
        // }
        // return false;

        if(this.textComponent.validate())
        {
          
        
            let userNameMaxLength = this.getUIProps().context.getResources().getString(Strings.username_max_length);

           
            if(this.textComponent.getData() < userNameMaxLength && this.textComponent.getData() > userNameMaxLength)
            {
                this.textComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                return false;
            }
            
            return true;   
        } 
        return false;    
    }    

    onRewardPointClick(): void
    {
        (this.getUIComponentHandler() as MyAccountComponentHandler).onRewardPointClick();  
    }

    showRewardPointPopUp(rewardPointDto: RewardPointDto): void
    {
        this.popUpComponent.setShowWindow(true, 
            <RewardPointComponent rewardPointDto={rewardPointDto}  id={"getRewardPoint"}  headerTitle={this.getContext().getResources().getString(Strings.reward_point_popup_header)} closePopup={this.closePopup} context={this.getContext()} />);
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/myaccountview.tsx